
import { defineComponent } from 'vue';
import Sidebar from '@/components/Sidebar.vue';
import Navbar from '@/components/Navbar.vue';
import Player from '@/components/Player.vue';

export default defineComponent({
  name: 'App',
  components: {
    Sidebar,
    Navbar,
    Player,
  },
  created() {
    this.$store.dispatch('init_login');
  },
});
